import * as React from "react";
const SvgSwarmia = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 31",
  width: "1em",
  height: "1em",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0E1829",
  d: "M12.559 12.353C9.987 5.899 15.332-.837 22.29.085a9.4 9.4 0 0 1 3.573 1.238l-1.055 4.13c-.76-.749-1.762-1.223-2.893-1.4a5.09 5.09 0 0 0-5.548 3.15 4.93 4.93 0 0 0 .006 3.71l2.492 6.256a9.514 9.514 0 0 1-4.454 11.992c-5.645 2.951-12.868.045-14.21-6.352-1.219-5.808 3.235-11.21 9.244-11.21h.566l-1.009 3.95c-3.246 0-5.549 3.455-4.794 6.444.746 3.698 5.011 5.276 8.25 3.595a5.54 5.54 0 0 0 2.592-6.98z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00A388",
  d: "M33.172 7.48h-1.948c-.406 0-.609 0-.778.07a.9.9 0 0 0-.375.29c-.11.146-.16.34-.26.73l-.87 3.405h-1.948c-.405 0-.608 0-.777.07a.9.9 0 0 0-.376.29c-.11.145-.16.34-.26.73l-.634 2.484H20.51l1.01-3.95h1.948c.405 0 .608 0 .777-.07a.9.9 0 0 0 .376-.29c.11-.146.16-.34.26-.73l.869-3.404h1.948c.406 0 .608 0 .777-.07a.9.9 0 0 0 .376-.29c.11-.146.16-.34.26-.73l1.198-4.692h4.436z"
}));
export default SvgSwarmia;
//# sourceMappingURL=Swarmia.js.map